<div class="branding_plans_main_page">
    <div class="branding_plans_text">
        Discover Our Branding Plans
    </div>
    <div class="branding_plans_button">
        <button style="border-radius: 0px;border: none;" (click)="monthly()" 
                class="monthly" 
                [ngStyle]="{'background': ismonthly ? '#ffe544' : 'black', 'color': ismonthly ? 'black' : '#ffe544'}">
            MONTHLY
        </button>
        <button style="border-radius: 0px;border: none;" (click)="annually()" 
                class="monthly"
                [ngStyle]="{'background': isannually ? '#ffe544' : 'black', 'color': isannually ? 'black' : '#ffe544'}">
            QUATERLY
        </button>
    </div>
    <div class="branding_plans_slider" *ngIf="ismonthly">
        <div class="branding_plans_sliders" (scroll)="onScroll($event)">
            <div class="branding_plans_card_1">
                <div class="image_icon" ><img src="\assets\ignite_icon.png" alt="IGNITE"
                    style="width:40px;height:40px; margin: 7px; display: inline-block; vertical-align: top;"></div>
                <div class="branding_plans_header">IGNITE PRO</div>
                <div [@flipAnimation]="currentState" class="branding_plans_ammount">₹&nbsp;<span class="branding_plans_discount_ammount">99999</span> 79999
                </div>
                <div style="font-size: 18px;
                text-align: center;
                font-family: var(--font);
                font-weight: 400;
                letter-spacing: 1px;">/ Month</div>
                <div class="branding_plans_details">
                    <div class="detail-item block_a"><img src="\assets\TICK_MARK_LOGO.png" alt="IGNITE"
                            style="width:23px;height:23px;margin-right: 10px;">Initial consultation,strategy & Basic
                        brand identity with ​guidlines(logo, colors, typography)</div>
                    <div class="detail-item block_a"><img src="\assets\TICK_MARK_LOGO.png" alt="IGNITE"
                            style="width:23px;height:23px;margin-right: 10px;">20 posts per month (Facebook,​Instagram,
                        Twitter)4 reels per month (1 per week)2 carousels per month Basic graphics and content creation
                    </div>
                    <div class="detail-item block_a"><img src="\assets\TICK_MARK_LOGO.png" alt="IGNITE"
                            style="width:23px;height:23px;margin-right: 10px;">1 micro-influencer collaboration​(10k-50k
                        followers)2 sponsored posts by the influencer Influencer selection and outreach</div>
                    <div class="detail-item block_a"><img src="\assets\TICK_MARK_LOGO.png" alt="IGNITE"
                            style="width:23px;height:23px;margin-right: 10px;">2 customized songs</div>
                    <div class="detail-item block_a"><img src="\assets\TICK_MARK_LOGO.png" alt="IGNITE"
                            style="width:23px;height:23px;margin-right: 10px;">Monthly performance reportBasic engagement
                        metrics (likes, ​comments, shares)</div>
                    <div class="detail-item block_a"><img src="\assets\TICK_MARK_LOGO.png" alt="IGNITE"
                            style="width:23px;height:23px;margin-right: 10px;">Website</div>
                </div>
                <div class="contact_us_button">Get Started
                    <div class="plan_curve"></div> 
                </div>
            </div>
            <div class="most_popular" >
                <div class="branding_media_most_popular_text">MOST POPULAR</div>
                <div class="branding_plans_card_2">
                    <div class="image_icon" ><img src="\assets\boost_icon.png" alt="BOOST"
                        style="width:40px;height:40px; margin: 7px; display: inline-block; vertical-align: top;"></div>
                    <div class="branding_plans_header">BOOST PRO</div>
                    <div [@flipAnimation]="currentState" class="branding_plans_ammount">₹&nbsp;<span class="branding_plans_discount_ammount">109999</span>
                        84999</div>
                    <div style="font-size: 18px;
                    text-align: center;
                    font-family: var(--font);
                    font-weight: 400;
                    letter-spacing: 1px;">/ Month</div>
                    <div class="branding_plans_details">
                        <div class="detail-item block_b"><img src="\assets\TICK_MARK_LOGO.png" alt="BOOST"
                                style="width:23px;height:23px;margin-right: 10px;">Comprehensive strategy, positioning ​&
                            advanced brand identity with detailed brand guidelines.</div>
                        <div class="detail-item block_b"><img src="\assets\TICK_MARK_LOGO.png" alt="BOOST"
                                style="width:23px;height:23px;margin-right: 10px;">30 posts per month (FB,
                            Instagram,​Twitter, LinkedIn)6 reels per month, 3 carousels per ​month along with advanced
                            graphics ​and content creation (animations)</div>
                        <div class="detail-item block_b"><img src="\assets\TICK_MARK_LOGO.png" alt="BOOST"
                                style="width:23px;height:23px;margin-right: 10px;">2 mid-tier influencers (50k-200k
                            ​followers), 4 sponsored posts by ​influencers.</div>
                        <div class="detail-item block_b"><img src="\assets\TICK_MARK_LOGO.png" alt="BOOST"
                                style="width:23px;height:23px;margin-right: 10px;">6 customized songs</div>
                        <div class="detail-item block_b"><img src="\assets\TICK_MARK_LOGO.png" alt="BOOST"
                                style="width:23px;height:23px;margin-right: 10px;">Monthly ad spend management ​(budget
                            excluded) Facebook, ​Instagram, and Google Ads setup and management</div>
                        <div class="detail-item block_b"><img src="\assets\TICK_MARK_LOGO.png" alt="BOOST"
                                style="width:23px;height:23px;margin-right: 10px;">Bi-weekly performance reports Advanced
                            engagement metrics and ​insights, Campaign analysis and ​optimization recommendations</div>
                        <div class="detail-item block_b"><img src="\assets\TICK_MARK_LOGO.png" alt="BOOST"
                                style="width:23px;height:23px;margin-right: 10px;">Website</div>
                                <div class="animation_section"></div>
                    </div>
                    <div class="contact_us_button">Get Started
                        <div class="plan_curve"></div> 
                    </div>

                </div>
            </div>
            <div class="branding_plans_card_3">
                <div class="image_icon" ><img src="\assets\viral_icon.png" alt="VIRAL"
                    style="width:40px;height:40px; margin: 7px; display: inline-block; vertical-align: top;"></div>
                <div class="branding_plans_header">VIRAL PRO</div>
                <div [@flipAnimation]="currentState" class="branding_plans_ammount">₹&nbsp;<span class="branding_plans_discount_ammount">119999</span> 89999
                </div>
                <div style="font-size: 18px;
                text-align: center;
                font-family: var(--font);
                font-weight: 400;
                letter-spacing: 1px;">/ Month</div>
                <div class="branding_plans_details">
                    <div class="detail-item block_c"><img src="\assets\TICK_MARK_LOGO.png" alt="VIRAL"
                            style="width:23px;height:23px;margin-right: 10px;">Full-scale strategy, including market
                        ​research, Premium brand identity& ​Comprehensive brand guidelines ​document</div>
                    <div class="detail-item block_c"><img src="\assets\TICK_MARK_LOGO.png" alt="VIRAL"
                            style="width:23px;height:23px;margin-right: 10px;">40 posts per month, 8 reels per ​month (2
                        per week) ,4 carousels per ​month, Premium graphics(high-​quality videos, animations,interactive
                        content)</div>
                    <div class="detail-item block_c"><img src="\assets\TICK_MARK_LOGO.png" alt="VIRAL"
                            style="width:23px;height:23px;margin-right: 10px;">2 mid-tier influencers (50k-200k
                        ​followers), 4 sponsored posts by ​influencers.</div>
                    <div class="detail-item block_c"><img src="\assets\TICK_MARK_LOGO.png" alt="VIRAL"
                            style="width:23px;height:23px;margin-right: 10px;">6 customized songs</div>
                    <div class="detail-item block_c"><img src="\assets\TICK_MARK_LOGO.png" alt="VIRAL"
                            style="width:23px;height:23px;margin-right: 10px;">Monthly ad spend management ​(budget
                        excluded) - Ads setup and ​management across multiple ​platforms (FB, IG, Google, LinkedIn) ​A/B
                        testing and advanced targeting ​strategies</div>
                    <div class="detail-item block_c"><img src="\assets\TICK_MARK_LOGO.png" alt="VIRAL"
                            style="width:23px;height:23px;margin-right: 10px;">Monthly webinars, Community ​management
                        and wxclusive content ​for loyal followers and customers</div>
                </div>
                <div class="contact_us_button">Get Started
                    <div class="plan_curve"></div> 
                </div>
            </div>
        </div>

        <div class="dots">
            <span class="dot" [class.active]="currentSlide === 0" (click)="setSlide(0)"></span>
            <span class="dot" [class.active]="currentSlide === 1" (click)="setSlide(1)"></span>
            <span class="dot" [class.active]="currentSlide === 2" (click)="setSlide(2)"></span>
        </div>
    </div>

    <div class="branding_plans_slider" *ngIf="!ismonthly">
        <div class="branding_plans_sliders" (scroll)="onScroll($event)">
            <div class="branding_plans_card_1">
                <div class="image_icon" ><img src="\assets\ignite_icon.png" alt="IGNITE"
                    style="width:40px;height:40px; margin: 7px; display: inline-block; vertical-align: top;"></div>
                <div class="branding_plans_header">IGNITE PRO</div>
                <div [@flipAnimation]="currentState" class="branding_plans_ammount">₹&nbsp;<span class="branding_plans_discount_ammount">99999</span> 79999
                </div>
                <div style="font-size: 18px;
                text-align: center;
                font-family: var(--font);
                font-weight: 400;
                letter-spacing: 1px;">/ annually</div>
                <div class="branding_plans_details">
                    <div class="detail-item block_a"><img src="\assets\TICK_MARK_LOGO.png" alt="IGNITE"
                            style="width:23px;height:23px;margin-right: 5px;">Initial consultation, strategy &
                        Basic brand identity with ​guidlines(logo, colors, typography)</div>
                    <div class="detail-item block_a"><img src="\assets\TICK_MARK_LOGO.png" alt="IGNITE"
                            style="width:23px;height:23px;margin-right: 5px;">20 posts per month
                        (Facebook,​Instagram, Twitter)4 reels per month (1 per week)2 carousels per month Basic graphics
                        and
                        content creation</div>
                    <div class="detail-item block_a"><img src="\assets\TICK_MARK_LOGO.png" alt="IGNITE"
                            style="width:23px;height:23px;margin-right: 5px;">1 micro-influencer
                        collaboration​(10k-50k followers)2 sponsored posts by the influencer Influencer selection and
                        outreach</div>
                    <div class="detail-item block_a"><img src="\assets\TICK_MARK_LOGO.png" alt="IGNITE"
                            style="width:23px;height:23px;margin-right: 5px;">2 customized songs</div>
                    <div class="detail-item block_a"><img src="\assets\TICK_MARK_LOGO.png" alt="IGNITE"
                            style="width:23px;height:23px;margin-right: 5px;">Monthly performance reportBasic
                        engagement metrics (likes, ​comments, shares)</div>
                    <div class="detail-item block_a"><img src="\assets\TICK_MARK_LOGO.png" alt="IGNITE"
                            style="width:23px;height:23px;margin-right: 5px;">Website</div>
                </div>
                <div class="contact_us_button">Get Started
                    <div class="plan_curve"></div> 
                </div>
            </div>
            <div class="most_popular">
                <div class="branding_media_most_popular_text">MOST POPULAR</div>
            <div class="branding_plans_card_2">
                <div class="image_icon" ><img src="\assets\boost_icon.png" alt="BOOST"
                    style="width:40px;height:40px; margin: 7px; display: inline-block; vertical-align: top;"></div>
                <div class="branding_plans_header">BOOST PRO</div>
                <div [@flipAnimation]="currentState" class="branding_plans_ammount">₹&nbsp;<span class="branding_plans_discount_ammount">109999</span> 84999
                </div>
                <div style="font-size: 18px;
                text-align: center;
                font-family: var(--font);
                font-weight: 400;
                letter-spacing: 1px;">/ annually</div>
                <div class="branding_plans_details">
                    <div class="detail-item block_b"><img src="\assets\TICK_MARK_LOGO.png" alt="BOOST"
                            style="width:23px;height:23px;margin-right: 5px;">Comprehensive strategy, 
                        positioning
                        ​& advanced brand identity with detailed brand guidelines.</div>
                    <div class="detail-item block_b"><img src="\assets\TICK_MARK_LOGO.png" alt="BOOST"
                            style="width:23px;height:23px;margin-right: 5px;">30 posts per month (FB,
                        Instagram, 
                        ​Twitter, LinkedIn)6 reels per month, 3 carousels per ​month along with advanced graphics ​and
                        content creation (animations)</div>
                    <div class="detail-item block_b"><img src="\assets\TICK_MARK_LOGO.png" alt="BOOST"
                            style="width:23px;height:23px;margin-right: 5px;">2 mid-tier influencers
                        (50k-200k
                        ​followers), 4 sponsored posts by ​influencers.</div>
                    <div class="detail-item block_b"><img src="\assets\TICK_MARK_LOGO.png" alt="BOOST"
                            style="width:23px;height:23px;margin-right: 5px;">6 customized songs</div>
                    <div class="detail-item block_b"><img src="\assets\TICK_MARK_LOGO.png" alt="BOOST"
                            style="width:23px;height:23px;margin-right: 5px;">Monthly ad spend management
                        ​(budget excluded) Facebook, ​Instagram, and Google Ads setup and management</div>
                    <div class="detail-item block_b"><img src="\assets\TICK_MARK_LOGO.png" alt="BOOST"
                            style="width:23px;height:23px;margin-right: 5px;">Bi-weekly performance reports
                        Advanced engagement metrics and ​insights, Campaign analysis and ​optimization recommendations
                    </div>
                    <div class="detail-item block_b"><img src="\assets\TICK_MARK_LOGO.png" alt="BOOST"
                            style="width:23px;height:23px;margin-right: 5px;">Website</div>
                </div>
                <div class="contact_us_button">Get Started
                    <div class="plan_curve"></div> 
                </div>
            </div>
        </div>
            <div class="branding_plans_card_3">
                <div class="image_icon" ><img src="\assets\viral_icon.png" alt="VIRAL"
                    style="width:40px;height:40px; margin: 7px; display: inline-block; vertical-align: top;"></div>
                <div class="branding_plans_header">VIRAL PRO</div>
                <div [@flipAnimation]="currentState" class="branding_plans_ammount">₹&nbsp;<span class="branding_plans_discount_ammount">119999</span> 89999
                </div>
                <div style="font-size: 18px;
                text-align: center;
                font-family: var(--font);
                font-weight: 400;
                letter-spacing: 1px;">/ annually</div>
                <div class="branding_plans_details">
                    <div class="detail-item block_c"><img src="\assets\TICK_MARK_LOGO.png" alt="VIRAL"
                            style="width:23px;height:23px;margin-right: 5px;">Full-scale strategy, including
                        market ​research, Premium brand identity& ​Comprehensive brand guidelines ​document</div>
                    <div class="detail-item block_c"><img src="\assets\TICK_MARK_LOGO.png" alt="VIRAL"
                            style="width:23px;height:23px;margin-right: 5px;">40 posts per month, 8 reels per
                        ​month (2 per week) ,4 carousels per ​month, Premium graphics(high-​quality videos, animations,
                        ​interactive content)</div>
                    <div class="detail-item block_c"><img src="\assets\TICK_MARK_LOGO.png" alt="VIRAL"
                            style="width:23px;height:23px;margin-right: 5px;">2 mid-tier influencers
                        (50k-200k
                        ​followers), 4 sponsored posts by ​influencers.</div>
                    <div class="detail-item block_c"><img src="\assets\TICK_MARK_LOGO.png" alt="VIRAL"
                            style="width:23px;height:23px;margin-right: 5px;">6 customized songs</div>
                    <div class="detail-item block_c"><img src="\assets\TICK_MARK_LOGO.png" alt="VIRAL"
                            style="width:23px;height:23px;margin-right: 5px;">Monthly ad spend management
                        ​(budget excluded) - Ads setup and ​management across multiple ​platforms (FB, IG, Google,
                        LinkedIn)
                        ​A/B testing and advanced targeting ​strategies</div>
                    <div class="detail-item block_c"><img src="\assets\TICK_MARK_LOGO.png" alt="VIRAL"
                            style="width:23px;height:23px;margin-right: 5px;">Monthly webinars, Community
                        ​management and wxclusive content ​for loyal followers and customers</div>
                </div>
                <div class="contact_us_button">Get Started
                    <div class="plan_curve"></div> 
                </div>
            </div>
        </div>
        <div class="dots">
            <span class="dot" [class.active]="currentSlide === 0" (click)="setSlide(0)"></span>
            <span class="dot" [class.active]="currentSlide === 1" (click)="setSlide(1)"></span>
            <span class="dot" [class.active]="currentSlide === 2" (click)="setSlide(2)"></span>
        </div>
    </div>

</div>